import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CookieService } from '@core/feature';
import { CookieAgreementService } from '@main/cookies-agreement/feature';
import { UserAgentService } from '@shared/services';

@Component({
  selector: 'ui-cookies-agreement',
  styleUrls: ['cookies-agreement.component.scss'],
  templateUrl: 'cookies-agreement.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookiesAgreementComponent implements OnInit {
  readonly cookieService = inject(CookieService);
  readonly userAgentService = inject(UserAgentService);
  private readonly cookieAgreementService = inject(CookieAgreementService);

  readonly showModal = this.cookieAgreementService.getModalState();

  ngOnInit(): void {
    this.cookieAgreementService.checkAgreement();
  }

  onChangeAgreement(): void {
    this.cookieAgreementService.setState(false);
  }
}
